module.exports = __webpack_public_path__ + "static/media/DownloadFiles.aa4ec82d.svg";